<template>
  <div
    class="main-layout predicted-xlcs-page predicted-item-page"
    v-loading="isLoading"
  >
    <el-card class="box-inner">
      <c-title slot="header" title="入学测试详情"></c-title>

      <div class="div-scroll" style="padding: 20px" v-if="testList.length">
        <CCollapseItem
          v-for="(item, index) in testList"
          :key="index"
          :showSearch="false"
        >
          <template slot="title-left">
            第{{ item.time }}次测试，得分：{{ item.score }}</template
          >
          <template slot="body">
            <div class="form-container">
              <el-form
                ref="form"
                :model="item"
                label-position="top"
                v-if="item.resultList.length"
                disabled
              >
                <el-form-item
                  :label="j + 1 + '、' + result.titleName"
                  v-for="(result, j) in item.resultList"
                  :key="result.id"
                >
                  <template slot="label">
                    <div class="label-title">
                      <span v-if="result.right" class="flag">(√)</span>
                      <span v-else class="flag">(×)</span>
                      <span>{{ j + 1 + "、" + result.titleName }}</span>
                    </div>
                  </template>
                  <el-radio-group v-model="result.optionId">
                    <el-radio
                      :label="option.optionId"
                      v-for="option in result.options"
                      :key="option.optionId"
                      >{{ option.optionName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </CCollapseItem>
      </div>
      <el-empty description="暂无数据" v-else></el-empty>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      handleData: {},
      titleData: [],
      resultData: [],
      isSubmit: false,
      isLoading: false,
      status: null,
      testList: [],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {
    this.getTestResult();
  },
  methods: {
    //查询入学测试结果
    getTestResult() {
      this.isLoading = true;
      return this.$http
        .get("/welcome-forecast/test/myTestResult")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.testList = res.data || [];
            console.log(this.testList);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.label-title {
  position: relative;
  line-height: 26px;
  .flag {
    position: absolute;
    left: -26px;
  }
}
</style>
